import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Button, DatePicker, Dropdown, Menu, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { FormColumn, FormRow, MarkupMainContainer } from '../../../StyledComponents/Markup';
import { DetailRow, TitleDiv } from '../../../StyledComponents/RateManagement';
import { TabTitle } from '../../../StyledComponents/CreateKeyAccountManager';

import { calculateMarkup } from '../../../store/Markup/markupSlice';
import DateInput from '../Common/DateInput';
import SelectSearchPort from '../Common/SelectSearchPort';
import { useDispatch, useSelector } from 'react-redux';
import { updatenotificationdata } from '../../../store/Common/CommonSlice';

// Validation schema using Yup
// const validationSchema = Yup.object({
//   customerCategory: Yup.string().required('Customer category is required'),
//   origin: Yup.string().required('Origin is required'),
//   destination: Yup.string().required('Destination is required'),
//   carrier: Yup.string().required('Carrier is required'),
//   commodity: Yup.string().required('Commodity is required'),
//   shipmentDate: Yup.date().required('Shipment date is required'),
// });

const validationSchema = Yup.object({
  customerCategory: Yup.string().required('Customer category is required'),
  origin: Yup.string()
    .required('Origin is required')
    .test(
      'not-same-as-destination',
      'Origin and destination cannot be the same',
      function (value) {
        // Access the destination field value using `this.parent`
        return value !== this.parent.destination;
      }
    ),
  destination: Yup.string()
    .required('Destination is required')
    .test(
      'not-same-as-origin',
      'Destination and origin cannot be the same',
      function (value) {
        // Access the origin field value using `this.parent`
        return value !== this.parent.origin;
      }
    ),
  carrier: Yup.string().required('Carrier is required'),
  commodity: Yup.string().required('Commodity is required'),
  shipmentDate: Yup.date().required('Shipment date is required'),
});

export const Simulator = () => {
  const [spinner, setSpinner] = useState(false);
  const [calculatedMarkupValue, setCalculatedMarkupValue] = useState(null);
  const [state, setState] = useState({
    airline_list: [],
    airport_list: [],
  });
  const { listOfAirport, listOfAirline, customerCategory } = useSelector((state) => state.markup);
  const initialValues = {
    customerCategory: '',
    origin: '',
    destination: '',
    carrier: '',
    commodity: '',
    shipmentDate: '',
  };
  const dispatch = useDispatch();
console.log("listOfAirport",listOfAirport[0])
  const handleMenuClick = (e, setFieldValue, fieldName) => {
    setFieldValue(fieldName, e.key);
  };

  const handleDateChange = (date, dateString, setFieldValue) => {
    
    setFieldValue('shipmentDate', date);
  };

  

  let cusomerCategegryData = customerCategory.map((element) => {
    return {
      _id: element._id,
      code: element.category_name,
      label: `Category ${element.category_name}`
    }
  })
  let formFields = [
    {
      label: 'Customer Category',
      name: 'customerCategory',
      placeholder: 'Select Category',
      options: cusomerCategegryData,
    },
    {
      label: 'Origin',
      name: 'origin',
      placeholder: 'Select Origin',
      options: listOfAirport.filter((elment)=>elment.code!="ALL"),
    },
    {
      label: 'Destination',
      name: 'destination',
      placeholder: 'Select Destination',
      options: listOfAirport.filter((elment)=>elment.code!="ALL"),
    },
    {
      label: 'Carrier',
      name: 'carrier',
      placeholder: 'Select Carrier',
      options: listOfAirline,
    },
    {
      label: 'Commodity',
      name: 'commodity',
      placeholder: 'Select Commodity',
      options: [
        { code: 'general', label: 'General' }
      ],
    },
    {
      label: 'Shipment Date',
      name: 'shipmentDate',
      type: 'date',
    },
  ];
  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      airline_list: listOfAirline,

      airport_list: listOfAirport,
    }));
  }, [calculatedMarkupValue]);
  return (
    <MarkupMainContainer>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm, setFieldValue }) => {

          const mappedValues = {
            origin: values.origin,
            customer_category: values.customerCategory,
            destination: values.destination,
            carrier: values.carrier,
            commodity: values.commodity,
            shipment_date: values.shipmentDate,
          };
          
          setSpinner(true)
          dispatch(calculateMarkup(mappedValues))
            .then((res) => {
              setCalculatedMarkupValue(res.payload.data);
              
              dispatch(updatenotificationdata(res.payload))

            }).catch((error) => {
              console.log("error", error)
              setCalculatedMarkupValue(null)
              dispatch(updatenotificationdata({
                "message": "Origin and Destination cannot be same.",
                "success": "error",
                "statusCode": 401,
                "data": []
              }
            ))
            
            })
            .finally(() => setSpinner(false));

        }}
      >
        {({ setFieldValue, values }) => (
          <Form className="flex flex-col ">

            {formFields.map((field) => (
              <FormRow className="flex flex-row  gap-6   md:justify-center mb-4">
                <FormColumn span={5} className="w-full md:w-[50%] text-left md:text-right md:pr-4">
                  <label htmlFor={field.name} className="block md:inline">
                    {field.label}
                  </label>
                </FormColumn>
                <FormColumn span={7} className=" w-full md:w-[50%] text-center  ">
                  <div className="flex flex-col w-full">
                    {field.type === 'date' ? (
                      <DatePicker className="w-full mx-auto text-center "
                        onChange={(date, dateString) => handleDateChange(date, dateString, setFieldValue)}
                        value={values.shipmentDate}
                        placeholder="Shipment Date"
                        disabledate={true}
                      />

                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: "#f1f1f1" }}>
                        <SelectSearchPort name={field.name} setFieldValue={setFieldValue} value={values.origin_port} options={field.options} width="100%" bradius="8px" placeholder={field.placeholder} />
              
                      </div>
                    )

                    }
                    <ErrorMessage
                      name={field.name}
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </FormColumn>
              </FormRow>
            ))}


            <div className="flex  w-full  ml-[50%] ">
              <Button
                className="bg-[#679fee] w-fit  font-normal md:font-medium"
                type="primary"
                htmlType="submit"
                loading={spinner}
              >
                Check Markup
              </Button>
            </div>
          </Form>
        )}
      </Formik>

      {
        calculatedMarkupValue && <DetailRow className='flex flex-row mt-10 gap-6  md:justify-center mb-4'>

          <TitleDiv className='w-[20%]' >
            <TabTitle>Markup % </TabTitle>
          </TitleDiv>
          <div className='w-[30%] bg-[#969191]  py-[3px] px-[10px] '>{calculatedMarkupValue}</div>


        </DetailRow>
      }


    </MarkupMainContainer>
  );
};

